module.exports = __webpack_public_path__ + "static/media/volunteers.250915cf.svg";